import styled from "styled-components";

export const Confianca = styled.section`
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 43px;
  padding-bottom: 100px;
  gap: 40px;
  background-color: var(--blue-white);

  h1 {
    font-weight: 700;
    font-size: 2.2rem;
    line-height: 122%;
    color: var(--title);
  }

  iframe {
    width: 50vw;
    height: 50vh;
  }

  @media (max-width: 601px) {
    padding-bottom: 60px;

    h1 {
        font-size: 1.5rem;
    }

    iframe {
      width: 85vw;
      height: 25vh;
    }
  }
`;
